// @flow
import { connect } from 'react-redux';
import type { RootState } from '../../../index';
import Footer from '../components/Footer';
import { actions as LocaleActions } from '../../../modules/locale/duck';
import { actions as EditProfileActions } from '../../../modules/preferences/edit-profile/duck';
import { bindActionCreators } from 'redux';

function mapStateToProps(state: RootState) {
  return {
    localeState: state.locale,
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...LocaleActions, ...EditProfileActions }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Footer);



// WEBPACK FOOTER //
// ./src/modules/footer/containers/FooterContainer.js